module.exports = __webpack_public_path__ + "static/media/home-bg-mobile.bddf6068.jpg";